import * as React from "react";
import icEye from "@/assets/icons/ic-eye.svg";
import icEyeOff from "@/assets/icons/ic-eye-off.svg";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input"> & { togglePassword?: boolean }
>(({ className, type, togglePassword, ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const isPassword = type === "password";
  const effectiveType = isPassword && showPassword ? "text" : type;

  return (
    <div className="relative">
      <input
        type={effectiveType}
        className={cn(
          "flex h-12 w-full rounded border border-[#00000027] font-bold bg-white px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[#B0B0B0] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm placeholder:text-[16px] placeholder:font-normal",
          className,
          isPassword && "pr-10",
        )}
        ref={ref}
        autoComplete="new-password"
        {...props}
      />
      {isPassword && togglePassword !== false && (
        <button
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8d8d8d] hover:text-[#202020] cursor-pointer"
          tabIndex={-1}
        >
          {showPassword ? <img src={icEyeOff} /> : <img src={icEye} />}
        </button>
      )}
    </div>
  );
});
Input.displayName = "Input";

export { Input };
